// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"776":"d0c93a99","940":"d0c93a99"}[chunkId] + ".chunk.css";
};